import React from 'react'

const TalkingOutLoudforKids = () => {
  return (
    <div>
      
<div class="title"><h1>Welcome to JP's Helping Hand</h1></div>
<div class="main">
  <div class="menubar">
    <ul>
      <li><a href="/">About Us</a></li>
      <li><a href="/TalkingOutLoudforKids">Talking Out loud for Kids</a></li>
      <li><a href="/TalkingOutLoudforEveryone">Talking Out loud for Everyone</a></li>
      <li><a href="https://docs.google.com/forms/d/e/1FAIpQLSf2f6PIk25F9-VIq4bTU1W9HAklzTdDJsJu6O6O506H-NMLng/viewform?usp=sf_link">Contact US</a></li>
      <li><a href="/PrivacyPolicy">Privacy Policy</a></li>
    </ul>
  </div>

  <h2>Talking Out loud for kids</h2>
  <img class="TOLlogo" src="img/TOLKlogo.png" width="200" />

  <p>Talking Out Loud for Kids is an AAC application for disabled kids who cannot express themselves verbally. TOL helps kids say what they are feeling and their wants. They can say what they want to eat, drink, go, or do. They also can say when something hurts. TOL is also for hospital patients who cannot communicate verbally and allows them to tell what hurts. TOL allows those who cannot speak to have a voice.</p>

  <div class="sreshts">
    <h3>Screenshots:</h3>
    <div class="row">
      <div class="column">
        <img src="img/TOLKScreenshot%20(1).png" style={{ width: "90%" }} />
      </div>
      <div class="column">
        <img src="img/TOLKScreenshot%20(2).png" style={{ width: "90%" }} />
      </div>
      <div class="column">
        <img src="img/TOLKScreenshot%20(3).png" style={{ width: "90%" }} />
      </div>
      <div class="column">
        <img src="img/TOLKScreenshot%20(4).png" style={{ width: "90%" }} />
      </div>
    </div>

  </div>
  <p>
    Download it now on Windows 10/11 devices, Android tablets, iPads, or Amazon Fire devices.
  </p>
  <p>
    <a href='//www.microsoft.com/store/apps/9PLZLRBHQNJ5?cid=storebadge&ocid=badge'><img src='img/ms.png' alt='English badge' style={{ width: "10%" }}/></a>
    <a href='https://play.google.com/store/apps/details?id=com.x.android.talkingoutloudforkids&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Get it on Google Play' src='img/google-play-badge.png' style={{ width: "11%" }}/></a>
    <a href='https://itunes.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=1478564139'><img alt='Get it on the App Store' src='img/app-storee.png' style={{ width: "11%" }}/></a>
    <a href='https://www.amazon.com/gp/product/B07SPHP6HM'><img alt='Get it on Amazon appstore' src='img/amazon-appstore-badge-english-black.png' style={{ width: "11%" }}/></a>
  </p>
  <p style={{ fontSize: "small" }}>
    Google Play and the Google Play logo are trademarks of Google LLC. <br/>
    Apple, the Apple logo, iPhone, and iPad are trademarks of Apple Inc., registered in the U.S. and other countries and regions. App Store is a service mark of Apple Inc.

  </p>
</div>
    </div>
  );
};

export default TalkingOutLoudforKids;